import { useEffect, useState } from 'react'
import { Trans } from 'react-i18next'

import {
  INTRO_ACCENT_COLOR,
  anatomyDigestivePNG,
  anatomyDigestiveWEBP,
} from '~/pages/anatomy/intro/libs/components/Anatomy/constants'
import { AnatomyStyles as S } from '~/pages/anatomy/intro/libs/components/Anatomy/styles'
import { Progress } from '~/shared/components/Progress'
import { eventLogger } from '~/shared/services/eventLogger'
import { appHistory } from '~/shared/utils'

const LOADER_DURATION_MS = 3500
const TICK_MS = 100
const QUESTION = 'Better than old Anatomy Books'

interface IAnatomyProps {
  nextPagePath: string
}

const Anatomy = ({ nextPagePath }: IAnatomyProps) => {
  const [progressPercent, setProgressPercent] = useState(0)

  useEffect(() => {
    let elapsed = 0

    const timer = setInterval(() => {
      elapsed += TICK_MS
      const percent = Math.min((elapsed / LOADER_DURATION_MS) * 100, 100)
      setProgressPercent(percent)

      if (elapsed >= LOADER_DURATION_MS) {
        clearInterval(timer)
        eventLogger.logFirstPageCompleted(QUESTION)
        eventLogger.logQuestion({
          question: QUESTION,
          pageName: 'intro-anatomy-1',
        })
        appHistory.goTo(nextPagePath)
      }
    }, TICK_MS)

    return () => clearInterval(timer)
  }, [nextPagePath])

  return (
    <S.Root>
      <S.ContentWrapper>
        <S.Title>
          <Trans
            ns="anatomy"
            i18nKey="onboarding.anatomyIntro.title"
            components={{ span: <span /> }}
          />
        </S.Title>

        <S.Subtitle>
          <Trans ns="anatomy" i18nKey="onboarding.anatomyIntro.subtitle" />
        </S.Subtitle>

        <S.Badges>
          <S.Badge>
            <Trans ns="anatomy" i18nKey="onboarding.anatomyIntro.quizBadge" />
          </S.Badge>
          <S.Badge>
            <Trans ns="anatomy" i18nKey="onboarding.anatomyIntro.ratingBadge" />
          </S.Badge>
        </S.Badges>

        <picture>
          <source srcSet={anatomyDigestiveWEBP} type="image/webp" />
          <S.Image src={anatomyDigestivePNG} alt="Anatomy Digestive System" />
        </picture>

        <S.LoaderSection>
          <S.LoaderText>
            <Trans ns="anatomy" i18nKey="onboarding.anatomyIntro.loaderText" />
          </S.LoaderText>

          <S.ProgressWrapper>
            <Progress
              color={INTRO_ACCENT_COLOR}
              $background="transparent"
              $valueBorderRadius="999px"
              $roundedAllSides
              value={progressPercent}
              max={100}
            />
          </S.ProgressWrapper>
        </S.LoaderSection>
      </S.ContentWrapper>
    </S.Root>
  )
}

export default Anatomy
